import { memo } from 'react';
import { TitleSourceSvg, VideoSourceSvg, JumpLinkOfQuestionSourceSvg } from '@/components/svg-icons/qa-records';
import { environment } from '@gaodun.com/gtools';
import { IQuestionSource } from '..';
import { toastInQa } from '@/utils/qa';
import { getGlobalStore } from '@/store/global';
import './index.scss';

const QuestionSource = ({
    sourceType,
    title,
    content,
    videoId,
    videoTime,
    questionId,
    permission,
    url,
}: Omit<IQuestionSource, 'recordId' | 'type' | 'role'>) => {
    const handleClickOrigin = () => {
        switch (sourceType) {
            case 'video':
                if (permission === 1) {
                    url
                        ? window.open(url)
                        : getGlobalStore()?.publish('VideoPlayerModal', {
                              type: 'open',
                              title,
                              params: { videoId, initialTime: videoTime },
                          });
                } else {
                    toastInQa('对不起，您未购买该课程，无法查看该视频。若要查看，请去购买哦。');
                }
                break;
            case 'question':
                {
                    let url = `https://${environment.getApiEnv()}sub-tiku.gaodun.com/single/question/${questionId}?color=5262ff`;
                    window.open(url);
                }
                break;
            default:
                break;
        }
    };

    return (
        <div className="respondent-container">
            <div className="question-source">
                <div className="question-source__title">问题来源</div>
                <div className="question-source__info" onClick={handleClickOrigin}>
                    {sourceType === 'video' ? (
                        <VideoSourceSvg className="question-source__icon" />
                    ) : (
                        <TitleSourceSvg className="question-source__icon" />
                    )}
                    <div className="question-source__title">{content}</div>
                    {sourceType === 'question' && <JumpLinkOfQuestionSourceSvg className="question-source__link-icon" />}
                </div>
            </div>
        </div>
    );
};

export default memo(QuestionSource);
